/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Space } from "antd";
import { useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import BackButtonIcon from "../../../../assets/icons/BackButtonIcon";
import CopyIcon from "../../../../assets/icons/CopyIcon";
import EditButtonIcon from "../../../../assets/icons/EditButtonIcon";
import { useGetTemplateDetailsQuery } from "../../../../features/superAdmin/ticketService/template/template.api";
import useCopy from "../../../../hooks/useCopy";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatSLA } from "../../../../utils/utils";
import WorkFlows from "../_components/WorkFlows";
import { TEMPLATE_TYPES } from "../constants/ticket.constants";
import ContentFromTemplate from "../Tickets/_components/ContentsFromTemplate";
import { capitalize } from "../../../../utils/string";

export default function TemplateDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const handleCopy = useCopy();

  const accordionRef = useRef<any>(null);
  const [uploading, setUploading] = useState(false);
  const user = useAppSelector((state) => state.auth);
  const { data } = useGetTemplateDetailsQuery(id || "");

  const templateDetails = data?.data;
  const workflowsData = data?.data?.ticketRoles;

  const fileUploadFieldsData = templateDetails?.requiredFields?.filter(
    (field) => field.required_field_type === "file_upload",
  );

  const othersFieldsData = templateDetails?.requiredFields?.filter(
    (field) => field.required_field_type !== "file_upload",
  );

  return (
    <SidebarLayout title="Ticket Management">
      <div className="flex justify-between bg-white p-4 border border-extra-light rounded-lg mb-6">
        <Button
          className="button-bordered-light h-10"
          onClick={() => navigate(-1)}
        >
          <BackButtonIcon />
          Back
        </Button>

        <Space>
          {!!(user?.role === "super_admin" || user?.role === "Admin") && (
            <Link
              to={`/admin/ticket-management/all-templates/edit-ticket/${id}`}
            >
              <Button className="button-bordered-gray h-10">
                <EditButtonIcon />
                Edit
              </Button>
            </Link>
          )}
        </Space>
      </div>

      <div className="flex justify-between items-center mb-8 border-b border-b-extra-light pb-7">
        <div className="text-[32px] font-semibold">{templateDetails?.name}</div>
        <div className="flex gap-2 text-display-body">
          <button
            className="cursor-pointer"
            onClick={() => handleCopy(templateDetails?.template_key as string)}
          >
            <CopyIcon />
          </button>
          <div>{templateDetails?.template_key}</div>
        </div>
      </div>

      <div className="flex justify-between items-center mb-8 border-b border-b-extra-light pb-7">
        {/* <div>
          <span className="text-base">Department: </span>
          <span className="text-lg font-medium text-header">
            {templateDetails?.department?.name}
          </span>
        </div> */}
        <div>
          <span className="text-base">Category: </span>
          <span className="text-lg font-medium text-header">
            {capitalize(templateDetails?.category as string)}
          </span>
        </div>
        <div>
          <span className="text-base">Type: </span>
          <span className="text-lg font-medium text-header">
            {templateDetails?.type}
          </span>
        </div>
        <div>
          <span className="text-base">SLA: </span>
          <span className="text-lg font-medium text-header">
            {formatSLA(templateDetails?.totalSLA)}
          </span>
        </div>
      </div>

      <ContentFromTemplate
        ref={accordionRef}
        othersFieldsData={othersFieldsData}
        fileUploadFieldsData={fileUploadFieldsData}
        setUploading={setUploading}
      />

      <WorkFlows
        isSlaBased={templateDetails?.type === TEMPLATE_TYPES.sla}
        workflowsData={workflowsData}
      />
    </SidebarLayout>
  );
}
